import {
  Component,
  Input,
  Output,
  ViewChild,
  ElementRef,
  EventEmitter,
  HostListener,
} from "@angular/core";
import { SelectMenuOption } from "../../form/select-menu/select-menu.component";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { TranslationService } from "../../_services/translation.service";
import { ITranslations } from "../../_models/ITranslations";
import { Observable } from "rxjs/Observable";
import { DateAndTimeUtils } from "../../_helpers/dateUtils";
import { sleep } from "../../_helpers/sleep";

@Component({
  selector: "date-range-select",
  templateUrl: "date-range-select.component.html",
  styleUrls: [
    "../../form/select-menu/select-menu.component.scss",
    "./date-range-select.component.scss",
  ],
  animations: [
    trigger("transformMenu", [
      state(
        "void",
        style({
          opacity: 0,
          transform: "scale(0.8)",
        })
      ),
      transition(
        "void => enter",
        animate(
          "120ms cubic-bezier(0, 0, 0.2, 1)",
          style({
            opacity: 1,
            transform: "scale(1)",
          })
        )
      ),
      transition(
        "* => void",
        animate("100ms 25ms linear", style({ opacity: 0 }))
      ),
    ]),
  ],
})
export class DateRangeSelectComponent {
  @Input("appearance") public appearance = "no-limit";
  @Input("length") public length: number;
  @Input("disabled") public disabled: boolean = false;
  @ViewChild("componentMain") public componentMain: ElementRef;
  public menuEvent: EventEmitter<SelectMenuOption> =
    new EventEmitter<SelectMenuOption>();
  public menuIsOpen: boolean = false;
  public dateTo: any;
  public dateFrom: any;
  public translations$: Observable<ITranslations>;
  public displayValue: string = "";

  constructor(
    translationService: TranslationService,
    private eRef: ElementRef
  ) {
    this.translations$ = translationService.translations;
  }

  public clickedOption($event: MouseEvent, key: string) {
    $event.stopPropagation();
    $event.stopImmediatePropagation();

    this.onTouchedCallback();
    // this.onChangeCallback(this.selectedOption);
    this.closeMenu();
  }

  public toggleMenu($event) {
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    if (this.disabled) {
      return;
    }
    this.menuIsOpen = !this.menuIsOpen;
    if (!this.menuIsOpen) {
      this.closeMenu();
      return;
    }
    setTimeout(() => {
      // this will make the execution after the above boolean has changed
      this.componentMain.nativeElement.focus();
    }, 10);
  }

  public closeMenu() {
    this.menuIsOpen = false;
  }

  //From ControlValueAccessor interface

  public onTouchedCallback: () => void = () => {};

  public onChangeCallback: (_: any) => void = () => {};

  public ngOnInit(): void {}

  public clickedInsideDateRange($event: MouseEvent) {
    $event.stopPropagation();
    $event.stopImmediatePropagation();
  }

  @HostListener("document:click", ["$event"])
  public clickOut(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
      // clicked inside do nothing
    } else {
      this.closeMenu();
    }
  }

  public async changeDate($event: any) {
    await sleep(20);
    this.displayValue = this.buildTextFromDates(this.dateFrom, this.dateTo);
  }

  private buildTextFromDates(dateFrom, dateTo) {
    let from = dateFrom ? DateAndTimeUtils.getDateFromEpoc(dateFrom) : "";
    let to = dateTo ? DateAndTimeUtils.getDateFromEpoc(dateTo) : "";
    if (from && to) {
      return `${from} - ${to}`;
    } else if (from) {
      return `${from} -`;
    } else if (to) {
      return ` - ${to}`;
    } else {
      return "";
    }
  }

  private registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  private registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  private writeValue(value: any) {
    // this.selectedOption = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/date-range-select/date-range-select.component.ts